"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = phoneNumber;
var _utils = require("../utils");
var _lib = require("../lib");
var _constants = require("../constants");
function phoneNumber(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.assertString)(value);
  var message = options.message,
    phonePrefix = options.phonePrefix,
    _options$isMobile = options.isMobile,
    isMobile = _options$isMobile === void 0 ? false : _options$isMobile;
  var defaultRegex = '^\\d+$';
  if ((0, _utils.checkValueExist)(phonePrefix)) {
    var pPrefix = String(phonePrefix);
    var prefix = _constants.RX_PHONES[pPrefix];
    if ((0, _utils.checkValueExist)(prefix)) {
      defaultRegex = prefix[String(isMobile)];
    }
  }
  var validRegex = new RegExp(options.validRegex || defaultRegex, 'i');
  var key = options.key || 'key';
  var validity = (0, _utils.createValidity)(key);
  if (value.length > 0 && !validRegex.test(value)) {
    var label = options.label || 'Field';
    var defaultMsg = "".concat(label, " is not a valid phone number");
    if (isMobile) {
      defaultMsg = "".concat(label, " is not a valid mobile number");
    }
    var messageOptions = {
      key: key,
      message: message,
      label: label,
      validRegex: validRegex
    };
    validity.isValid = false;
    validity.message = (0, _lib.getMessage)(messageOptions, defaultMsg);
  }
  return validity;
}


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/web-validations/dist/validations/phoneNumber.js
// module id = 1893
// module chunks = 0